import { EventManager } from './event-manager.service';
var ModuleManagerService = /** @class */ (function () {
    function ModuleManagerService() {
    }
    ModuleManagerService.prototype.init = function () {
        this.components = Array.from(document.querySelectorAll('[data-component]'));
        this.event = EventManager.Instance;
        this.assemble();
    };
    ModuleManagerService.prototype.assemble = function () {
        var _this = this;
        this.components.forEach(function (item, index) {
            var currentComponent = _this.purify(_this.components[index].getAttribute('data-component'));
            _this.compile(currentComponent, _this.components[index]);
        });
        this.event.emit('componentsLoaded');
    };
    ModuleManagerService.prototype.purify = function (name) {
        if (name.includes('-')) {
            return name.split('-').map(function (item) {
                return item = item.substring(0, 1).toUpperCase() + item.substring(1);
            }).join('');
        }
        else {
            return name.substring(0, 1).toUpperCase() + name.substring(1);
        }
    };
    ModuleManagerService.prototype.compile = function (moduleName, el) {
        if (typeof this.modules[moduleName] === 'function') {
            new this.modules[moduleName](el);
        }
        else {
            console.warn("Looked for module '" + moduleName + "' but could'nt find it. Check if it's registered in the app.ts file");
        }
    };
    return ModuleManagerService;
}());
export { ModuleManagerService };



//////////////////
// WEBPACK FOOTER
// ./services/module-manager.service.ts
// module id = 33
// module chunks = 0